<div class="card m-0">
  <form class="form">
    <hs-fill-symbolizer [symbolizer]="symbolizer" (changes)="emitChange()" *ngIf="symbolizer.kind === kinds.fill">
    </hs-fill-symbolizer>
    <hs-line-symbolizer [symbolizer]="symbolizer" (changes)="emitChange()" *ngIf="symbolizer.kind === kinds.line">
    </hs-line-symbolizer>
    <hs-mark-symbolizer [symbolizer]="symbolizer" (changes)="emitChange()" *ngIf="symbolizer.kind === kinds.mark">
    </hs-mark-symbolizer>
    <hs-icon-symbolizer [symbolizer]="symbolizer" (changes)="emitChange()" *ngIf="symbolizer.kind === kinds.icon">
    </hs-icon-symbolizer>
    <hs-text-symbolizer [symbolizer]="symbolizer" (changes)="emitChange()" *ngIf="symbolizer.kind === kinds.text">
    </hs-text-symbolizer>
  </form>
</div>